// @flow

import React, { type Node } from 'react';
import styled  from 'styled-components';

import { Separator } from '../../../../commons/atoms';
import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';

import { MailWarning } from './mail-warning';
import { BoletoNumber } from './boleto-number';
import { BoletoBarcode } from './boleto-barcode';
import { BoletoTipsBox } from './boleto-tips-box';
import { DisplayDueDate } from './display-due-date';
import { SaveToPdfButton } from './save-to-pdf-button';
import { DisplayTotalAmount } from './display-total-amount';
import { CopyToClipboardButton } from './copy-to-clipboard-button';

export function BoletoPageContent(): Node {
  const features = useAllFeatures();

  return (
    <Root data-test-id="page-pending-payment">

      <BoletoTitle>
        Seu boleto foi gerado! :)
      </BoletoTitle>

      <IfFeature allFeatures={features} wanted="display_boleto_email_warning">
        <MailWarning />
      </IfFeature>

      <PaymentInfoWrapper>

        <IfFeature allFeatures={features} wanted="display_boleto_total_value">
          <DisplayTotalAmount />
        </IfFeature>

        <IfFeature allFeatures={features} wanted="display_boleto_due_date">
          <DisplayDueDate />
        </IfFeature>

      </PaymentInfoWrapper>

      <Separator direction="vertical" pattern="dotted" size={5} />

      <IfFeature allFeatures={features} wanted="display_boleto_barcode">
        <BoletoBarcode />
      </IfFeature>

      <IfFeature allFeatures={features} wanted="display_boleto_number">
        <BoletoNumber />
      </IfFeature>

      <IfFeature allFeatures={features} wanted="action_boleto_copy_code">
        <CopyToClipboardButton />
      </IfFeature>

      <IfFeature allFeatures={features} wanted="action_boleto_save_pdf">
        <SaveToPdfButton />
      </IfFeature>

      <Separator direction="vertical" pattern="dotted" size={6} />

      <IfFeature allFeatures={features} wanted="display_boleto_tips">
        <BoletoTipsBox />
      </IfFeature>

    </Root>
  );
}

const Root = styled.div``;

const PaymentInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 15px;
  background: #f8f8f9;
`;

const BoletoTitle = styled.p`
  font-size: 22px;
  font-family: ${props => props.theme.fontFamily.display};
  color: #2397d4;
  margin-bottom: 16px;
`;
